<template>
  <div id="header__controls" class="header-controls">
    <b-modal centered hide-footer id="feedbackModal" title="Send Feedback">
      <FeedbackModal ref="refFeedbackModal" />
    </b-modal>
    <div class="container-fluid">
      <div class="row">
        <div class="col-xs-7 col-md-8 col-8 left-side">
          <div class="form-inline">
            <div class="input-group top-search">
              <input
                type="text"
                class="form-control media-calls-search"
                v-model="searchQuery"
                v-debounce:500ms="setQuery"
                :debounce-events="['keyup']"
                placeholder="Search deliverables..."
                @click="$refs.searchQuery.select()"
                @keypress.enter="generateReport()"
                ref="searchQuery"
                id="search-query"
              />
              <div class="input-group-append cursor-pointer" @click="generateReport()">
                <span class="input-group-text">
                  <i class="fas fa-search"></i>
                </span>
              </div>
            </div>
            <b-button
              ref="filterBoxBtn"
              id="popover-button-event"
              class="ml-2 header-filter-btns"
              variant="theme"
              tabindex="0"
              href="#"
              @keydown.esc="$refs.popover.$emit('close')"
            >
              Filter
              <img src="@/csmworkflow/img/filter.svg" />
            </b-button>
            <b-popover
              triggers="click blur"
              placement="bottom"
              ref="popover"
              target="popover-button-event"
              custom-class="deliverable-filter"
            >
              <div class="d-flex flex-row">
                <div class="filter-item item__status">
                  <label>Status</label>
                  <div v-if="!isMobile()" class="status-wrap">
                    <a
                      href="#"
                      @click="setStatusFilter(s)"
                      class="badge mr-2"
                      :style="{color: '#fff', backgroundColor: s.color}"
                      v-for="(s, index) in statuses"
                      :key="index"
                    >{{ s.name }}</a>
                  </div>
                  <div class="custom-field status-field">
                    <multiselect
                      v-if="isMobile()"
                      :searchable="true"
                      v-model="filterQuery.status"
                      label="name"
                      :options="statuses"
                      placeholder="Select status"
                      :show-labels="false"
                      :multiple="true"
                      :hide-selected="true"
                    >
                      <template slot="option" slot-scope="props">
                        <div
                          :style="{ color: '#fff', borderRadius: '10px', backgroundColor: props.option.color, height: '40px', lineHeight: '40px', textAlign: 'center' }"
                        >{{ props.option.name }}</div>
                      </template>
                      <template slot="tag" slot-scope="props">
                        <div
                          :style="{ color: '#fff', borderRadius: '10px', backgroundColor: props.option.color, textAlign: 'center', display: 'inline-block', padding: '5px 10px', marginRight: '5px' }"
                        >{{ props.option.name }}</div>
                      </template>
                    </multiselect>
                  </div>
                </div>
                <div class="grouped-filter-item">
                  <div class="filter-item item__outlet">
                    <div>
                      <label>Contact</label>
                      <b-form-checkbox
                        v-if="isMobile()"
                        class="float-right csm-checkbox"
                        v-model="filterQuery.noOutlet"
                        id="no-outlet"
                        name="no-outlet"
                        value="accepted"
                        unchecked-value="not_accepted"
                        @input="filterQuery.noOutlet == 'accepted' ? filterQuery.outlet = [] : ''"
                      >
                        No Contact
                      </b-form-checkbox>
                    </div>
                    <div class="outlet-wrap">
                      <multiselect
                        ref="outletFilter"
                        v-model="filterQuery.outlet"
                        track-by="id"
                        id="id"
                        open-direction="bottom"
                        label="name"
                        :options="contacts"
                        :show-labels="false"
                        :searchable="true" 
                        :multiple="true"
                        :options-limit="300" 
                        :close-on-select="false"
                        :internal-search="false" 
                        :hide-selected="true"
                        :preserve-search="true"
                        :clear-on-select="false"
                        :show-no-results="false"
                        :max-height="600" 
                        :loading="isContactsLoading"
                        @select="filterQuery.noOutlet='not_accepted'"
                        @search-change="onWhoSearch"
                      >
                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                          <span
                            class="multiselect__single"
                            v-if="values.length && !isOpen"
                          >{{ values.length }} options selected</span>
                        </template>
                        <template slot="option" slot-scope="props">
                          <div class="option__desc">
                            <span class="option__title">{{ props.option.name }}</span><br>
                            <span class="option__small text-muted">{{ props.option.company_name }}</span>
                          </div>
                        </template>
                        <template slot="noOptions">
                          Start typing to find contacts.
                        </template>

                        <template slot="noResult">
                          No results. Please try changing the search query.
                        </template>
                      </multiselect>
                    </div>
                    <b-form-checkbox
                      v-if="!isMobile()"
                      class="mt-2 csm-checkbox"
                      v-model="filterQuery.noOutlet"
                      id="no-outlet"
                      name="no-outlet"
                      value="accepted"
                      unchecked-value="not_accepted"
                      @input="filterQuery.noOutlet == 'accepted' ? filterQuery.outlet = [] : ''"
                    >
                      No Contact
                    </b-form-checkbox>
                  </div>
                  <div class="filter-item item__outlet">
                    <label>Company</label>
                    <div class="outlet-wrap">
                      <multiselect
                        ref="outletCompanyFilter"
                        v-model="filterQuery.outletCompany"
                        id="id"
                        open-direction="bottom"
                        :options="allCompanies"
                        :show-labels="false"
                        :searchable="true" 
                        :multiple="true"
                        :options-limit="300" 
                        :close-on-select="false"
                        :hide-selected="true"
                        :preserve-search="true"
                        :clear-on-select="false"
                        :show-no-results="false"
                        :max-height="600" 
                      >
                      </multiselect>
                    </div>
                  </div>
                  <div class="filter-item item__coordinator">
                    <label>Coordinator</label>
                    <div class="coordinator-wrap">
                      <multiselect
                        ref="coordinatorFilter"
                        v-model="filterQuery.coordinator"
                        :options="allUsers"
                        :show-labels="false"
                        :multiple="true"
                        open-direction="bottom"
                        label="name"
                        track-by="id"
                        :hideSelected="false"
                        :hide-selected="false"
                        :close-on-select="false"
                        :clear-on-select="false"
                      >
                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                          <span
                            class="multiselect__single"
                            v-if="values.length && !isOpen"
                          >{{ values.length }} options selected</span>
                        </template>
                      </multiselect>
                    </div>
                  </div>
                </div>
                <div class="grouped-filter-item">
                  <div class="filter-item item__department">
                    <div>
                      <label>
                        Department
                      </label>
                      <b-form-checkbox
                          v-if="isMobile()"
                          class="float-right csm-checkbox"
                          v-model="filterQuery.noDepartment"
                          id="no-department"
                          name="no-department"
                          value="accepted"
                          unchecked-value="not_accepted"
                          @input="filterQuery.noDepartment == 'accepted' ? filterQuery.department = [] : ''"
                        >No Department</b-form-checkbox>
                    </div>
                    <div class="tag-wrap">
                      <multiselect
                        ref="departmentFilter"
                        v-model="filterQuery.department"
                        open-direction="bottom"
                        label="name"
                        track-by="id"
                        :options="departments"
                        :hideSelected="false"
                        :hide-selected="false"
                        :show-labels="false"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        @select="filterQuery.noDepartment = 'not_accepted'"
                      >
                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                          <span
                            class="multiselect__single"
                            v-if="values.length && !isOpen"
                          >{{ values.length }} options selected</span>
                        </template>
                        <template slot="noOptions">
                          Start typing to find departments.
                        </template>


                        <template slot="noResult">
                          No results. Please try changing the search query.
                        </template>
                      </multiselect>
                    </div>
                    <b-form-checkbox
                      v-if="!isMobile()"
                      class="mt-2 csm-checkbox"
                      v-model="filterQuery.noDepartment"
                      id="no-department"
                      name="no-department"
                      value="accepted"
                      unchecked-value="not_accepted"
                      @input="filterQuery.noDepartment == 'accepted' ? filterQuery.department = [] : ''"
                    >
                      No Department
                    </b-form-checkbox>
                  </div>
                  <div class="filter-item item__tag">
                    <label>Tag</label>
                    <div class="tag-wrap">
                      <multiselect
                        ref="tagFilter"
                        v-model="filterQuery.tag"
                        :options="tags"
                        :show-labels="false"
                        :multiple="true"
                        open-direction="bottom"
                        label="name"
                        track-by="id"
                        :hideSelected="false"
                        :hide-selected="false"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :loading="isTagsLoading"
                        :preserve-search="true"
                        @search-change="onTagSearch"
                      >
                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                          <span
                            class="multiselect__single"
                            v-if="values.length && !isOpen"
                          >{{ values.length }} options selected</span>
                        </template>
                        <template slot="noOptions">
                          Start typing to find tags.
                        </template>

                        <template slot="noResult">
                          No results. Please try changing the search query.
                        </template>
                      </multiselect>
                    </div>
                  </div>
                </div>
                <div class="filter-item item__date">
                  <div class="due__created__dates">
                    <div>
                      <label>Due Date</label>
                      <br />
                      <date-range-picker
                        ref="picker"
                        @update="onUpdateDueDate"
                        :autoApply="true"
                        :showDropdowns="true"
                        :ranges="customDueDateRanges"
                        v-model="filterQuery.dateRange"
                      ></date-range-picker>
                    </div>
                    <div>
                      <label class="mt-2">Created</label>
                      <br />
                      <date-range-picker
                        ref="pickerDateCreated"
                        @update="onUpdateDateCreated"
                        :autoApply="true"
                        :showDropdowns="true"
                        :ranges="customCreatedDateRanges"
                        v-model="filterQuery.dateCreatedRange"
                      ></date-range-picker>
                    </div>
                  </div>

                  <div>
                    <label class="mt-2">Completed</label>
                    <br />
                    <date-range-picker
                      ref="pickerDateCompleted"
                      @update="onUpdateDateCompleted"
                      :autoApply="true"
                      :showDropdowns="true"
                      :ranges="customCompletedDateRanges"
                      v-model="filterQuery.dateCompletedRange"
                    ></date-range-picker>
                  </div>
                </div>
                <div class="filter-item filter-item-no-border item__priority">
                  <label>Priority</label>
                  <br />
                  <div @click="setPriority" class="filter-rating">
                    <vue-star-rate
                      :rateRange="filterQuery.priorityFilter"
                      :maxIcon="5"
                      :iconHeight="17"
                      :iconWidth="17"
                      :hasCounter="false"
                      iconColor="#4C9850"
                      iconColorHover="#4C9850"
                      iconShape="circle"
                    ></vue-star-rate>
                  </div>
                </div>
                <div class="item__reset">
                  <b-button variant="theme" v-b-tooltip.hover title="Reset All Filter" size="sm" @click="resetFilter"><i class="fas fa-undo"></i></b-button>
                  <b-button class="d-block d-md-none" variant="theme" title="Close Filter Popup" size="sm" @click="$refs.popover.$emit('close')"><i class="fas fa-times"></i></b-button>
                </div>
              </div>
              <div
                class="d-none d-md-block mt-3"
                v-if="isFilterActive()"
              >
                <label>Click to remove filters:</label>
                <br />
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="filterQuery.query = ''; searchQuery = ''"
                  :style="{cursor: 'pointer'}"
                >{{ filterQuery.query }}</span>
                <span
                  class="badge mr-2 mb-2"
                  @click="removeFilter(status)"
                  :style="{cursor: 'pointer', color: '#fff', backgroundColor: status.color}"
                  v-for="status in filterQuery.status"
                >{{ status.name }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter(outlet)"
                  :style="{cursor: 'pointer'}"
                  v-for="outlet in filterQuery.outlet"
                >{{ outlet.name }}</span>
                <span
                  v-if="filterQuery.priorityFilter > 0"
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter('resetPriorityFilter')"
                  :style="{cursor: 'pointer'}"
                >Priority {{ filterQuery.priorityFilter }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter(coordinator)"
                  :style="{cursor: 'pointer'}"
                  v-for="coordinator in filterQuery.coordinator"
                >{{ coordinator.name }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter('filterByDate')"
                  :style="{cursor: 'pointer'}"
                  v-if="filterQuery.filterByDate"
                >Due Date: {{ filterQuery.dateRange.startDate | moment('MMM DD') }} - {{ filterQuery.dateRange.endDate | moment('MMM DD') }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="filterQuery.filterNoDueDate=false"
                  :style="{cursor: 'pointer'}"
                  v-if="filterQuery.filterNoDueDate == 1"
                >No Due Date</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter('filterByDateCreated')"
                  :style="{cursor: 'pointer'}"
                  v-if="filterQuery.filterByDateCreated"
                >Created: {{ filterQuery.dateCreatedRange.startDate | moment('MMM DD') }} - {{ filterQuery.dateCreatedRange.endDate | moment('MMM DD') }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter('filterByDateCompleted')"
                  :style="{cursor: 'pointer'}"
                  v-if="filterQuery.filterByDateCompleted"
                >Completed: {{ filterQuery.dateCompletedRange.startDate | moment('MMM DD') }} - {{ filterQuery.dateCompletedRange.endDate | moment('MMM DD') }}</span>


                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter(tag)"
                  :style="{cursor: 'pointer'}"
                  v-for="tag in filterQuery.tag"
                >{{ tag.name }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter(department)"
                  :style="{cursor: 'pointer'}"
                  v-for="department in filterQuery.department"
                >{{ department.name }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter({company_name: company})"
                  :style="{cursor: 'pointer'}"
                  v-for="company in filterQuery.outletCompany"
                >{{ company }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="filterQuery.noDepartment='not_accepted'"
                  :style="{cursor: 'pointer'}"
                  v-if="filterQuery.noDepartment == 'accepted'"
                >No Department</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="filterQuery.noOutlet='not_accepted'"
                  :style="{cursor: 'pointer'}"
                  v-if="filterQuery.noOutlet == 'accepted'"
                >No Outlet</span>
              </div>
            </b-popover>

            <!-- report types -->
            <div class="report-type mr-2">
              <multiselect
                ref="reportType"
                v-model="reportType"
                :options="allReports"
                :show-labels="false"
                :multiple="false"
                :allow-empty="false"
                @input="$emit('reportTypeChanged', reportType); generateReport();"
                track-by="id"
                label="name"
                open-direction="bottom"
              >
              </multiselect>
            </div>
            <!-- report types -->
            
            <b-form-group>
              <div v-if="isMobile()" class="mobile__date__triggers">
                <multiselect
                  ref="dateFilterTrigger"
                  v-model="triggerSelected"
                  :options="dateTriggers"
                  :show-labels="false"
                  :multiple="false"
                  :allow-empty="false"
                  @input="setDateTriggerMobile"
                  open-direction="bottom"
                >
                </multiselect>
              </div>
              <div v-if="!isMobile()">
                <label class="btn-theme date-filter-triggers">
                  <b-form-radio
                    ref="weekly"
                    v-model="triggerSelected"
                    class="csm-checkbox"
                    id="weekly"
                    value="weekly"
                    name="createdDateTrigger"
                    @change="filterQuery.filterByDateCreated = true; filterQuery.dateCreatedRange.startDate = $moment().subtract(7, 'days').startOf('week').format(); filterQuery.dateCreatedRange.endDate = $moment().subtract(7, 'days').endOf('week').format();"
                  >
                    Weekly
                  </b-form-radio>
                </label>
                <label class="btn-theme ml-2 date-filter-triggers">
                  <b-form-radio
                    ref="biweekly"
                    v-model="triggerSelected"
                    value="biweekly"
                    class="csm-checkbox"
                    id="biweekly"
                    name="createdDateTrigger"
                    @change="filterQuery.filterByDateCreated = true; filterQuery.dateCreatedRange.startDate = $moment().subtract(14, 'days').startOf('week').format(); filterQuery.dateCreatedRange.endDate = $moment().subtract(7, 'days').endOf('week').format();"
                  >
                    Bi-Weekly
                  </b-form-radio>
                </label>
                <label class="btn-theme ml-2 date-filter-triggers">
                  <b-form-radio
                    ref="monthly"
                    v-model="triggerSelected"
                    class="csm-checkbox"
                    id="monthly"
                    value="monthly"
                    name="createdDateTrigger"
                    @change="filterQuery.filterByDateCreated = true; filterQuery.dateCreatedRange.startDate = $moment().subtract(1, 'months').startOf('month').format(); filterQuery.dateCreatedRange.endDate = $moment().subtract(1, 'months').endOf('month').format();"
                  >
                    Monthly
                  </b-form-radio>
                </label>
              </div>
            </b-form-group>
            
            <div class="ml-2">
              <FeedbackBtn />
            </div>
          </div>
          <div
            class="mt-3"
            v-if="isFilterActive()"
          >
            <label class="remove-filter-text">Click to remove filters:</label>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="filterQuery.query = ''; searchQuery = ''"
              :style="{cursor: 'pointer'}"
            >{{ filterQuery.query }}</span>
            <span
              class="badge mr-2 mb-2"
              @click="removeFilter(status)"
              :style="{cursor: 'pointer', color: '#fff', backgroundColor: status.color}"
              v-for="status in filterQuery.status"
            >{{ status.name }}</span>
            <span
                  v-if="filterQuery.priorityFilter > 0"
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter('resetPriorityFilter')"
                  :style="{cursor: 'pointer'}"
                >Priority {{ filterQuery.priorityFilter }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter(outlet)"
              :style="{cursor: 'pointer'}"
              v-for="outlet in filterQuery.outlet"
            >{{ outlet.name }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter(coordinator)"
              :style="{cursor: 'pointer'}"
              v-for="coordinator in filterQuery.coordinator"
            >{{ coordinator.name }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter('filterByDate')"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.filterByDate"
            >Due Date: {{ filterQuery.dateRange.startDate | moment('MMM DD') }} - {{ filterQuery.dateRange.endDate | moment('MMM DD') }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="filterQuery.filterNoDueDate=false"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.filterNoDueDate == 1"
            >No Due Date</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter('filterByDateCreated')"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.filterByDateCreated"
            >Created: {{ filterQuery.dateCreatedRange.startDate | moment('MMM DD') }} - {{ filterQuery.dateCreatedRange.endDate | moment('MMM DD') }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter('filterByDateCompleted')"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.filterByDateCompleted"
            >Completed: {{ filterQuery.dateCompletedRange.startDate | moment('MMM DD') }} - {{ filterQuery.dateCompletedRange.endDate | moment('MMM DD') }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter(tag)"
              :style="{cursor: 'pointer'}"
              v-for="tag in filterQuery.tag"
            >{{ tag.name }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter(department)"
              :style="{cursor: 'pointer'}"
              v-for="department in filterQuery.department"
            >{{ department.name }}</span>
            <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter({company_name: company})"
                  :style="{cursor: 'pointer'}"
                  v-for="company in filterQuery.outletCompany"
                >{{ company }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="filterQuery.noDepartment='not_accepted'"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.noDepartment == 'accepted'"
            >No Department</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="filterQuery.noOutlet='not_accepted'"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.noOutlet == 'accepted'"
            >No Outlet</span>
          </div>
        </div>
        <div class="col-xs-5 col-md-4 col-4 text-right right-side">
          <div class="logo-user">
            <HeaderNotification />
            <LoggedInUser />
            <Logo />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Logo from "./Logo";
import LoggedInUser from "./LoggedInUser";
import HeaderNotification from "./HeaderNotification";
import FeedbackBtn from "./FeedbackBtn";
import FeedbackModal from "./FeedbackModal";
import router from "../../routes";
import toast from "../../toast";
import vueStarRate from "vue-js-star-rating";

export default {
  data() {
    return {
      triggerSelected: false,
      dateTriggers: [
        'weekly', 'biweekly', 'monthly'
      ],
      reportType: {name: 'Calls by Department', id: 'callsByDepartment'},
      allReports: [
        {name: 'Calls by Department', id: 'callsByDepartment'},
        {name: 'Calls by Outlet', id: 'callsByOutlet'},
        {name: 'Calls by Tag', id: 'callsByTrendingTag'},
        {name: 'Full List', id: 'fullList'},
      ],
      customDueDateRanges: {
        'No Due Date': [null, null],
        'Yesterday': [this.$moment().subtract(1, 'days').toDate(), this.$moment().subtract(1, 'days').toDate()],
        'Last week': [this.$moment().subtract(7, 'days').startOf('week').toDate(), this.$moment().subtract(7, 'days').endOf('week').toDate()],
        'Last two week': [this.$moment().subtract(14, 'days').startOf('week').toDate(), this.$moment().subtract(7, 'days').endOf('week').toDate()],
        'Today': [this.$moment().toDate(), this.$moment().toDate()],
        'This week': [this.$moment().startOf('week').toDate(), this.$moment().endOf('week').toDate()],
        'Next week': [this.$moment().startOf('week').add(7, 'days').toDate(), this.$moment().endOf('week').add(7, 'days').toDate()],
        'Next two weeks': [this.$moment().startOf('week').add(7, 'days').toDate(), this.$moment().endOf('week').add(14, 'days').toDate()],
      },
      customCreatedDateRanges: {
        'Yesterday': [this.$moment().subtract(1, 'days').toDate(), this.$moment().subtract(1, 'days').toDate()],
        'Last week': [this.$moment().subtract(7, 'days').startOf('week').toDate(), this.$moment().subtract(7, 'days').endOf('week').toDate()],
        'Last two week': [this.$moment().subtract(14, 'days').startOf('week').toDate(), this.$moment().subtract(7, 'days').endOf('week').toDate()],
        'Today': [this.$moment().toDate(), this.$moment().toDate()],
        'This week': [this.$moment().startOf('week').toDate(), this.$moment().endOf('week').toDate()]
      },
      customCompletedDateRanges: {
        'Yesterday': [this.$moment().subtract(1, 'days').toDate(), this.$moment().subtract(1, 'days').toDate()],
        'Last week': [this.$moment().subtract(7, 'days').startOf('week').toDate(), this.$moment().subtract(7, 'days').endOf('week').toDate()],
        'Last two week': [this.$moment().subtract(14, 'days').startOf('week').toDate(), this.$moment().subtract(7, 'days').endOf('week').toDate()],
        'Today': [this.$moment().toDate(), this.$moment().toDate()],
        'This week': [this.$moment().startOf('week').toDate(), this.$moment().endOf('week').toDate()]
      },
      searchQuery: '',
      isContactsLoading: false,
      isTagsLoading: false,
      isDepartmentsLoading: false,
      contacts: [],
      tags: [],
      departments: [],
      showUserSelect: false,
      filterQuery: {}
    };
  },
  components: {
    Logo,
    LoggedInUser,
    FeedbackBtn,
    FeedbackModal,
    HeaderNotification,
    vueStarRate
  },
  computed: {
    ...mapGetters(["allCompanies", "allCustomFields", "reportFilter", "allUsers", "allContacts", "allTags", "deliverableFilter", "initialContacts", "initialTags", "initialDepartments", "userAbilities"]),
    statuses() {
      let statusField = _.find(this.allCustomFields, { field_key: "status" });
      if (typeof statusField != "undefined") {
        let valueSet = [],
          data = JSON.parse(statusField.value_set);
        Object.keys(data).forEach(function(item) {
          valueSet.push(data[item]);
        });
        return valueSet;
      }
    }
  },
  mounted() {
    // hiding the header logo when scrolling in mobile
    if(this.isMobile() && this.$store.getters.isLoggedIn) {
      var prevScrollpos = window.pageYOffset;
      window.onscroll = function() {
        var currentScrollPos = window.pageYOffset;
        if (prevScrollpos > currentScrollPos) {
          document.getElementById("header__controls").style.top = "0";
        } else {
          document.getElementById("header__controls").style.top = "-60px";
        }
        prevScrollpos = currentScrollPos;
      }
    }
    this.fetchAllCustomFields();
		this.fetchUsers();
    this.onWhoSearch('')
    this.onTagSearch('')
    this.onDepartmentSearch('')
    this.filterQuery = this.reportFilter;
    if(this.isMobile()) {
      this.triggerSelected = 'biweekly';
      this.filterQuery.filterByDateCreated = true; 
      this.filterQuery.dateCreatedRange.startDate = this.$moment().subtract(14, 'days').startOf('week').format(); 
      this.filterQuery.dateCreatedRange.endDate = this.$moment().subtract(7, 'days').endOf('week').format();
    } else {
      $('#biweekly').trigger('click');
    }
    if(!this.filterQuery.filterByDate) {
      this.filterQuery.dateRange = {
        startDate: new Date(),
        endDate: new Date()
      }
    }
    if(!this.filterQuery.filterByDateCreated) {
      this.filterQuery.dateCreatedRange = {
        startDate: new Date(),
        endDate: new Date()
      }
    }
    if(!this.filterQuery.filterByDateCompleted) {
      this.filterQuery.dateCompletedRange = {
        startDate: new Date(),
        endDate: new Date()
      }
    }
  },
  methods: {
    ...mapActions([
      'fetchAllCustomFields',
      'fetchUsers'
    ]),
    isFilterActive() {
      return this.filterQuery.noDepartment == 'accepted' || this.filterQuery.noOutlet == 'accepted' || this.filterQuery.filterNoDueDate || this.filterQuery.query != '' || this.filterQuery.status.length || this.filterQuery.filterByDate || this.filterQuery.filterByDateCreated || this.filterQuery.filterByDateCompleted || this.filterQuery.coordinator.length || this.filterQuery.outlet.length || this.filterQuery.tag.length || this.filterQuery.department.length || this.filterQuery.outletCompany.length || this.filterQuery.priorityFilter > 0;
    },
    setDateTriggerMobile() {
      if(this.triggerSelected == 'weekly') {
        this.filterQuery.filterByDateCreated = true; 
        this.filterQuery.dateCreatedRange.startDate = this.$moment().subtract(7, 'days').startOf('week').format(); 
        this.filterQuery.dateCreatedRange.endDate = this.$moment().subtract(7, 'days').endOf('week').format();
      } else if(this.triggerSelected == 'biweekly') {
        this.filterQuery.filterByDateCreated = true; 
        this.filterQuery.dateCreatedRange.startDate = this.$moment().subtract(14, 'days').startOf('week').format(); 
        this.filterQuery.dateCreatedRange.endDate = this.$moment().subtract(7, 'days').endOf('week').format();
      } else if(this.triggerSelected == 'monthly') {
        this.filterQuery.filterByDateCreated = true; 
        this.filterQuery.dateCreatedRange.startDate = this.$moment().subtract(1, 'months').startOf('month').format(); 
        this.filterQuery.dateCreatedRange.endDate = this.$moment().subtract(1, 'months').endOf('month').format();
      }
    },
    setPriority() {
      let priority = $('.filter-rating .vue-star-rate ul.list li.active').length;
      this.filterQuery.priorityFilter = priority;
    },
    prevDate() {
      switch(this.triggerSelected) {
        case 'biweekly':
          this.filterQuery.dateCreatedRange.startDate = this.$moment(this.filterQuery.dateCreatedRange.startDate).subtract(14, 'days').startOf('week').format(); 
          this.filterQuery.dateCreatedRange.endDate = this.$moment(this.filterQuery.dateCreatedRange.endDate).subtract(14, 'days').endOf('week').format();
          break;
        case 'weekly':
          this.filterQuery.dateCreatedRange.startDate = this.$moment(this.filterQuery.dateCreatedRange.startDate).subtract(7, 'days').startOf('week').format(); 
          this.filterQuery.dateCreatedRange.endDate = this.$moment(this.filterQuery.dateCreatedRange.endDate).subtract(7, 'days').endOf('week').format();
          break;
        case 'monthly':
          this.filterQuery.dateCreatedRange.startDate = this.$moment(this.filterQuery.dateCreatedRange.startDate).subtract(1, 'months').startOf('month').format(); 
          this.filterQuery.dateCreatedRange.endDate = this.$moment(this.filterQuery.dateCreatedRange.endDate).subtract(1, 'months').endOf('month').format();
          break;
        default: 
          let days = this.$moment(this.filterQuery.dateCreatedRange.endDate).diff(this.$moment(this.filterQuery.dateCreatedRange.startDate), 'days') + 1;
          if(days == 0) {
            days = 1;
          }
          this.filterQuery.dateCreatedRange.startDate = this.$moment(this.filterQuery.dateCreatedRange.startDate).subtract(days, 'days').format(); 
          this.filterQuery.dateCreatedRange.endDate = this.$moment(this.filterQuery.dateCreatedRange.endDate).subtract(days, 'days').format();
          break;
      }
    },
    nextDate() {
      switch(this.triggerSelected) {
        case 'biweekly':
          this.filterQuery.dateCreatedRange.startDate = this.$moment(this.filterQuery.dateCreatedRange.startDate).add(14, 'days').startOf('week').format(); 
          this.filterQuery.dateCreatedRange.endDate = this.$moment(this.filterQuery.dateCreatedRange.endDate).add(14, 'days').endOf('week').format();
          break;
        case 'weekly':
          this.filterQuery.dateCreatedRange.startDate = this.$moment(this.filterQuery.dateCreatedRange.startDate).add(7, 'days').startOf('week').format(); 
          this.filterQuery.dateCreatedRange.endDate = this.$moment(this.filterQuery.dateCreatedRange.endDate).add(7, 'days').endOf('week').format();
          break;
        case 'monthly':
          this.filterQuery.dateCreatedRange.startDate = this.$moment(this.filterQuery.dateCreatedRange.startDate).add(1, 'months').startOf('month').format(); 
          this.filterQuery.dateCreatedRange.endDate = this.$moment(this.filterQuery.dateCreatedRange.endDate).add(1, 'months').endOf('month').format();
          break;
        default: 
          let days = this.$moment(this.filterQuery.dateCreatedRange.endDate).diff(this.$moment(this.filterQuery.dateCreatedRange.startDate), 'days') + 1;
          this.filterQuery.dateCreatedRange.startDate = this.$moment(this.filterQuery.dateCreatedRange.startDate).add(days, 'days').format(); 
          this.filterQuery.dateCreatedRange.endDate = this.$moment(this.filterQuery.dateCreatedRange.endDate).add(days, 'days').format();
          break;
      }
    },
    setQuery() {
      this.filterQuery.query = this.searchQuery
    },
    onUpdateDueDate() {
      this.filterQuery.filterByDate = true;
      this.filterQuery.filterNoDueDate = false;
      this.focusFilterBtn();
    },
    onUpdateDateCreated() {
      this.triggerSelected = false;
      this.filterQuery.filterByDateCreated = true;
      this.focusFilterBtn();
    },
    onUpdateDateCompleted() {
      this.filterQuery.filterByDateCompleted = true;
      this.focusFilterBtn();
    },


    onWhoSearch(input) {
      if(input != '' || this.initialContacts.length == 0) {
        this.isContactsLoading = true;
        if(typeof window.LIT !== 'undefined') {
          clearTimeout(window.LIT);
        }
        window.LIT = setTimeout(() => {
          input = input == false ? '' : input
          new Promise((resolve, reject) => {
            axios
              .get(process.env.MIX_API_BASE_URL + "activeContacts?q=" + encodeURI(input))
              .then(resp => {
                let x = 0;
                this.contacts = [];
                for (x = 0; x < resp.data.length; x++) {
                  resp.data[x]['name'] = resp.data[x]['first_name'] + ' ' + resp.data[x]['last_name']
                  this.contacts.push(resp.data[x]);
                }
                this.$store.commit('setInitialData', {contacts: this.contacts})
                this.isContactsLoading = false
                resolve(this.contacts);
              })
              .catch(error => {
                reject(error);
              });
          });
        }, 500);
      } else {
        this.contacts = this.initialContacts
      }
    },

    onTagSearch(input) {
      if(input != '' || this.initialTags.length == 0) {
        this.isTagsLoading = true
        if(typeof window.LIT1 !== 'undefined') {
          clearTimeout(window.LIT1);
        }
        window.LIT1 = setTimeout(() => {
          input = input == false ? '' : input
          new Promise((resolve, reject) => {
            axios
              .get(process.env.MIX_API_BASE_URL + "tags?q=" + encodeURI(input))
              .then(resp => {
                this.isTagsLoading = false
                this.tags = []
                let x = 0;
                for (x = 0; x < resp.data.length; x++) {
                  this.tags.push(resp.data[x]);
                }
                this.$store.commit('setInitialData', {tags: this.tags})
                resolve(this.tags);
              })
              .catch(error => {
                reject(error);
              });
          });
        }, 500);
      } else {
        this.tags = this.initialTags;
      }
    },
    onDepartmentSearch(input) {
      if(input != '' || this.initialDepartments.length == 0) {
        this.isDepartmentsLoading = true;
        if(typeof window.LIT2 !== 'undefined') {
          clearTimeout(window.LIT2);
        }
        window.LIT2 = setTimeout(() => {
          input = input == false ? '' : input
          new Promise((resolve, reject) => {
            axios
              .get(process.env.MIX_API_BASE_URL + "activeDepartments?q=" + encodeURI(input))
              .then(resp => {
                this.isDepartmentsLoading = false;
                this.departments = [];
                let x = 0;
                for (x = 0; x < resp.data.length; x++) {
                  this.departments.push(resp.data[x]);
                }
                this.$store.commit('setInitialData', {departments: this.departments})
                resolve(this.departments);
              })
              .catch(error => {
                this.isTagsLoading = false;
                reject(error);
              });
          });
        }, 500);
      } else {
        this.departments = this.initialDepartments;
      }
    },
    resetFilter() {
      this.triggerSelected = false;
      this.filterQuery.filterNoDueDate = false;
      this.filterQuery.noDepartment = 'not_accepted';
      this.filterQuery.noOutlet = 'not_accepted';
      this.filterQuery.query = "";
      this.searchQuery = "";
      this.filterQuery.priorityFilter = 0;
      this.filterQuery.filterByDate = false;
      this.filterQuery.dateRange = {
        startDate: new Date(),
        endDate: new Date()
      };

      this.filterQuery.filterByDateCreated = false;
      this.filterQuery.dateCreatedRange = {
        startDate: new Date(),
        endDate: new Date()
      };

      this.filterQuery.filterByDateCompleted = false;
      this.filterQuery.dateCompletedRange = {
        startDate: new Date(),
        endDate: new Date()
      };
      this.filterQuery.status = [];
      this.filterQuery.outlet = [];
      this.filterQuery.tag = [];
      this.filterQuery.coordinator = [];
      this.filterQuery.department = [];
      this.filterQuery.outletCompany = [];
    },
    outside() {
      this.showUserSelect = false;
    },
    setStatusFilter(status) {
      if (this.filterQuery.status.indexOf(status) != -1) {
        this.removeFilter(status);
      } else {
        this.filterQuery.status.push(status);
      }
    },
    removeFilter(data) {
      if (typeof data != "undefined") {
      	if (typeof data == "string") {
          if(data == 'resetPriorityFilter') {
           this.filterQuery.priorityFilter = 0; 
            $('.filter-rating .vue-star-rate ul li').each(function() {
              $(this).removeClass('active');
            });
          }
          if (data == "filterByDate") {
            this.filterQuery.filterByDate = false;
            this.filterQuery.dateRange.startDate = new Date();
            this.filterQuery.dateRange.endDate = new Date();
          }
          if (data == "filterByDateCreated") {
            this.triggerSelected = false;
            this.filterQuery.filterByDateCreated = false;
            this.filterQuery.dateCreatedRange.startDate = new Date();
            this.filterQuery.dateCreatedRange.endDate = new Date();
          }
          if (data == "filterByDateCompleted") {
              this.filterQuery.filterByDateCompleted = false;
              this.filterQuery.dateCompletedRange.startDate = new Date();
              this.filterQuery.dateCompletedRange.endDate = new Date();
          }
      	} else {
	        this.filterQuery.status = this.filterQuery.status.filter(s => {
	          return s.name != data.name;
	        });
	        this.filterQuery.coordinator = this.filterQuery.coordinator.filter(
	          s => {
	            return s.name != data.name;
	          }
	        );
	        this.filterQuery.outlet = this.filterQuery.outlet.filter(s => {
	          return s.name != data.name;
	        });
	        this.filterQuery.tag = this.filterQuery.tag.filter(s => {
	          return s.name != data.name;
	        });
	        this.filterQuery.department = this.filterQuery.department.filter(s => {
	          return s.name != data.name;
          });
          this.filterQuery.outletCompany = this.filterQuery.outletCompany.filter(s => {
	          return s != data.company_name;
	        });
	      }
      } else {
      		// TODO:  Check if a filter can be anything other than a string or object.
      }
    },
    focusFilterBtn() {
      this.$refs.filterBoxBtn.focus();
    },
    generateReport() {
      let that = this;
      toast.info('Generating report...');
      this.$store.dispatch("getReport", {reportType: this.reportType.id}).then(function(response) {
        that.$emit('reportGenerated', response);
      }).catch(error => {
        toast.hide();
      });
    }
  },
  watch: {
    filterQuery: {
      handler: function(val, oldVal) {
        this.filterQuery["myWeek"] = false;
        if(this.filterQuery.filterByDate && this.filterQuery.dateRange.startDate == null) {
          this.filterQuery.filterByDate = false
          this.filterQuery.dateRange = {
            startDate: new Date(),
            endDate: new Date()
          }
          this.filterQuery.filterNoDueDate = true
        }
        if(this.filterQuery.filterNoDueDate) {
          this.filterQuery.filterByDate = false
        }
        
        this.$store.commit('setDeliverableFilter', this.filterQuery)
        
        this.generateReport()

        if (
          this.filterQuery.query == "" &&
          !this.filterQuery.filterByDate &&
          !this.filterQuery.filterByDateCreated &&
          !this.filterQuery.filterByDateCompleted &&
          !this.filterQuery.status.length &&
          !this.filterQuery.coordinator.length &&
          !this.filterQuery.tag.length &&
          !this.filterQuery.department.length &&
          !this.filterQuery.outletCompany.length &&
          !this.filterQuery.outlet.length &&
          this.filterQuery.noDepartment != 'accepted' &&
          this.filterQuery.noOutlet != 'accepted' &&
          !this.filterQuery.filterNoDueDate &&
          this.filterQuery.priorityFilter == 0
        ) {
          $(".report-wrapper").removeClass("hasFilter");
        } else {
          $(".report-wrapper").addClass("hasFilter");
        }
        this.$emit("reportFilterUpdated", val);
      },
      deep: true
    }
  }
};
</script>

<style>
</style>